import React from 'react'
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core'

const RetentionTime = () => {
  const classes = useStyles()
  return (
    <Box>
      <Typography variant="h6">Retention time</Typography>
      <Typography variant="body1">
        Personal Data shall be processed and stored for as long as required by
        the purpose they have been collected for.
      </Typography>
      <Typography variant="body1">Therefore;</Typography>
      <Box component="ul">
        <Typography component="li" variant="body1">
          Personal Data collected for purposes related to the performance of a
          contract between the Owner and the User shall be retained until such
          contract has been fully performed.
        </Typography>
        <Typography component="li" variant="body1">
          Personal Data collected for the purposes of the Owner’s legitimate
          interests shall be retained as long as needed to fulfill such
          purposes. Users may find specific information regarding the legitimate
          interests pursued by the Owner within the relevant sections of this
          document or by contacting the Owner.{' '}
        </Typography>
      </Box>
      <Typography variant="body1">
        The Owner may be allowed to retain Personal Data for a longer period
        whenever the User has given consent to such processing, as long as such
        consent is not withdrawn. Furthermore, the Owner may be obliged to
        retain Personal Data for a longer period whenever required to do so for
        the performance of a legal obligation or upon order of an authority.
      </Typography>

      <Typography>
        Once the retention period expires, Personal Data shall be deleted.
        Therefore, the right to access, the right to erasure, the right to
        rectification and the right to data portability cannot be enforced after
        expiration of the retention period.
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles((theme) => createStyles({}))

export default RetentionTime
